"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceLink = void 0;
var React = require("react");
var styledButton_1 = require("../common/styledButton");
var styledButtonSecondary_1 = require("../common/styledButtonSecondary");
var styledLink_1 = require("../common/styledLink");
var styledLinkSecondary_1 = require("../common/styledLinkSecondary");
var styles_1 = require("@material-ui/core/styles");
var styles = styles_1.makeStyles(function (theme) { return ({
    customColour: function (props) { return ({
        backgroundColor: props.color,
        borderColor: props.color,
        color: theme.palette.getContrastText(props.color),
        '&:hover': {
            backgroundColor: styles_1.alpha(props.color, 0.7),
        }
    }); },
}); });
var IceLink = function (_a) {
    //const [slug, setSlug] = React.useState('');
    var pages = _a.pages, variant = _a.variant, to = _a.to, color = _a.color, children = _a.children;
    /*React.useEffect(() => {
        const linkedPage = pages.filter((x: { itemId: string }) => x.itemId == to)[0];

        if (linkedPage) {
            var link = linkedPage.slug.raw;
            var firstChar = link.substr(0);
            if (firstChar != '/') {
                link = '/' + link;
            }

            setSlug(link);
        } else {
            console.warn(`Page not found. Page id: ${to}`);
            setSlug("/404/");
        }
    }, [to]);*/
    var linkedPage = pages.filter(function (x) { return x.itemId == to; })[0];
    var getLink = function () {
        if (linkedPage) {
            var link = linkedPage.slug.raw;
            var firstChar = link.substr(0);
            if (firstChar != '/') {
                link = '/' + link;
            }
            var lastChar = link.substr(-1);
            if (lastChar != '/') {
                link = link + '/';
            }
            return link;
        }
        else {
            return "/404/";
        }
    };
    var theme = styles_1.useTheme();
    var classes = styles({ color: color ? color : theme.palette.primary.main });
    if (variant === "button") {
        return (React.createElement(styledButton_1.default, { href: getLink(), variant: "contained", className: classes.customColour }, children));
    }
    else if (variant === "button-secondary") {
        return (React.createElement(styledButtonSecondary_1.default, { href: getLink(), variant: "contained" }, children));
    }
    else if (variant === "link-secondary") {
        return (React.createElement(styledLinkSecondary_1.default, { color: "inherit", href: getLink() }, children));
    }
    else {
        return (React.createElement(styledLink_1.default, { color: "inherit", href: getLink() }, children));
    }
};
exports.IceLink = IceLink;
exports.IceLink.NAME = "IceLink";
exports.default = exports.IceLink;
//# sourceMappingURL=IceLink.js.map